import { Routes } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { RootComponent } from './root/root.component';

export const routing: Routes = [
  {
    path: 'login',
    component:  RootComponent,

    children: [
      { path: 'changePassword', component: ChangePasswordComponent },
      { path: 'changePassword/:token', component: ChangePasswordComponent },
      { path: '', component: LoginComponent },   
    ]
  }
];
